<template>
  <section>
    <div class="inner">
      <div class="header">Latest Obituaries</div>
      <div class="slide">
        <div class="grid">
          <router-link
            :key="obit.ItemID"
            :to="{ name: 'obit', params: { itemid: obit.ItemID, name: urlFormat(obit.name) } }"
            v-for="obit in latest_obits"
          >
            <span
              :style="{backgroundImage:'url(' + (obit.image ? obit.image : '/obit.jpg') + ')'}"
              :title="obit.name"
              class="image"
            ></span>
            <span class="info">
              <span class="name">{{ obit.name }}</span>
              <span
                class="date"
              >{{formatDate(obit.date_of_birth)}} - {{formatDate(obit.date_of_death)}}</span>
            </span>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex"
import { mapGetters } from "vuex"
import stringutil from "@/utils/formatstring"
import datetimeutil from "date-and-time"

export default {
  computed: {
    ...mapState(["page", "latest_obits"]),
    ...mapGetters(["isHomePage"])
  },
  mixins: [stringutil],
  methods: {
    formatDate(int) {
      return datetimeutil.format(new Date(int * 1000), "MMM YYYY")
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
section {
  padding: 6rem 0;
  text-align: center;
  background: #f7f7f7;
}

.header {
  font-size: 3rem;
  margin-bottom: 4rem;
  text-align: center;
  font-family: "Merriweather", sans-serif;
  color: #231f20;
}

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  overflow: hidden;
  transition: all 0.2s;
  grid-gap: 3rem;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .grid {
    display: table;
    width: 100%;
  }
  .grid > * {
    width: 23%;
    float: left;
    margin-right: 2%;
  }
}

.info {
  padding: 1rem 2rem;
  display: block;
}

.image {
  height: 30rem;
  display: block;
  background-image: url(../assets/obit.jpg);
  background-size: cover;
  background-position: center center;
  transition: all 0.2s;
}

a:nth-child(3) .image {
  background-image: url(../assets/obit2.jpg);
}

a:nth-child(2) .image {
  background-image: url(../assets/obit3.jpg);
}

a:nth-child(4) .image {
  background-image: url(../assets/obit4.jpg);
}

.grid a {
  transition: all 0.2s;
  padding-bottom: 1rem;
}

.grid a:hover .image {
  filter: brightness(1.05);
}

.name {
  display: block;
  font-size: 2.5rem;
  color: #bb9765;
  font-family: "Merriweather", sans-serif;
}

.slide {
  width: 100%;
}

.date {
  display: block;
  color: #999;
  font-size: 1.5rem;
}

.controls {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  pointer-events: none;
  z-index: 3;
}

.next {
  float: right;
  transform: translateX(50%);
}

.prev {
  transform: translateX(-50%);
}

.controls a {
  pointer-events: all;
  position: relative;
  border: 2px solid #272425;
  display: block;
  width: 5rem;
  height: 5rem;
  background: white;
  border-radius: 100%;
  line-height: 4.8rem;
  text-align: center;
  font-size: 2rem;
  transition: all 0.2s;
}

.controls a:hover {
  color: #a39064;
  border: 2px solid #a39064;
}

@media screen and (max-width: 750px) {
  .grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media screen and (max-width: 500px) {
  .header {
    font-size: 3rem;
  }
}

@media screen and (max-width: 450px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
</style>
